<template>
  <div
    :class="[
      'c--tabs_route-switcher-tabs',
      'route-switcher-tabs noselect',
      {
        'active-white': isActiveWhite,
      },
    ]"
  >
    <ul>
      <li v-for="(tab, index) in tabs" :key="`route-switcher-tabs-${index}`" :data-testid="`${tab.text}-tab`">
        <nuxt-link
          :to="localePath(tab.route)"
          :class="{
            'active-tab': tab.route.name === activeTabRouteName,
          }"
        >
          {{ tab.text }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      isActiveWhite: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    computed: {
      activeTabRouteName() {
        return this.getRouteBaseName()
      },
    },
  }
</script>
